import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function LoginPage() {
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [mode, setMode] = useState('magic')   // magic | password
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState(null)

  async function submit(e) {
    e.preventDefault()
    setBusy(true); setMsg(null)
    try {
      if (mode === 'magic') {
        const { error } = await supabase.auth.signInWithOtp({
          email,
          options: { emailRedirectTo: `${window.location.origin}/health` },
        })
        if (error) throw error
        setMsg('Check deine E-Mails — Magic-Link geschickt.')
      } else {
        const { error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) throw error
        nav('/health', { replace: true })
      }
    } catch (e) {
      setMsg(e.message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen grid place-items-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 border border-white/10 rounded-lg p-6 animate-system-open">
        <div className="section-h">Login</div>

        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="email@you.com"
          className="w-full bg-transparent border border-white/15 rounded-md px-3 py-2 focus:border-[var(--accent)] outline-none"
        />

        {mode === 'password' && (
          <input
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="password"
            className="w-full bg-transparent border border-white/15 rounded-md px-3 py-2 focus:border-[var(--accent)] outline-none"
          />
        )}

        <button disabled={busy} className="w-full py-2.5 rounded-md bg-[var(--accent)] text-black font-semibold tap disabled:opacity-50">
          {busy ? '…' : (mode === 'magic' ? 'Send Magic Link' : 'Sign in')}
        </button>

        <button type="button" onClick={() => setMode((m) => m === 'magic' ? 'password' : 'magic')}
                className="w-full text-xs label-mini hover:text-[var(--accent)]">
          {mode === 'magic' ? 'use password instead' : 'use magic link instead'}
        </button>

        {msg && <div className="text-xs opacity-80 text-center">{msg}</div>}

        <div className="text-center text-xs opacity-70">
          Noch keinen Account? <Link to="/signup" className="text-[var(--accent)]">Signup</Link>
        </div>
      </form>
    </div>
  )
}
